import clsx from 'clsx'
import React from 'react'
import styles from './PolicyTemplateIcon.module.scss'

function PolicyTemplateIcon() {
  return (
    <div>
      <i className="fas fa-file" />
      <i className={clsx('fas fa-shield-alt', styles.shieldBackground)} />
      <i className={clsx('fas fa-shield-alt', styles.shield)} />
    </div>
  )
}

export default PolicyTemplateIcon
